import { animate, state, style, transition, trigger } from '@angular/animations';

export const MENU_FLY_IN_OUT = trigger('flyInOutMenu', [
  state(
    'in',
    style({
      transform: 'translateX(0%)'
    })
  ),
  state(
    'out',
    style({
      transform: 'translateX(-100%)'
    })
  ),
  transition('in <=> out', [animate('0.25s ease-out')])
]);
